import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Education from "@/components/Education";
import Consultations from "@/components/Consultations";
import Workshops from "@/components/Workshops";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function HomePage() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Education />
        <Consultations />
        <Workshops />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
